const CheckPriceState = {
  selected: { merk: '', tipe: '', silinder: '', tahun: '', seri: '', kota: '' },
  selected_cari_harga: {
    city: '',
    period: '',
    brand: '',
    series: '',
    cylinder: '',
    type: '',
    year: '',
    startYear: '',
    endYear: '',
    transmisi: '',
  },
  minmaxprice: 0,
  score: { eksterior: 0, interior: 0, mesin: 0, rangka: 0 },
  chart: {},
};

export const checkPriceReducer = (state = CheckPriceState, action) => {
  if (action.type == 'SET_SELECTED_CEK_HARGA') {
    return {
      ...state,
      selected: action.value,
    };
  }

  if (action.type == 'SET_CHART') {
    return {
      ...state,
      chart: action.value,
    };
  }

  if (action.type == 'SET_SERIES') {
    return {
      ...state,
      series: action.value,
    };
  }

  if (action.type == 'SET_SELECTED_CARI_HARGA') {
    return {
      ...state,
      selected_cari_harga: action.value,
    };
  }

  if (action.type == 'SET_MIN_MAX') {
    return {
      ...state,
      minmaxprice: action.value,
    };
  }

  if (action.type == 'SET_SCORE') {
    return {
      ...state,
      score: action.value,
    };
  }

  return state;
};
